<div *ngFor="let section of sections">
  <h3>{{ section.title }}</h3>
  <div [innerHTML]="section.body | mdToHtml"></div>
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
